<template>
   <div class="card mb-4">
      <div class="card-header bg-info text-light">
         Signup Information
      </div>
      <div class="card-body">
         <h4>Profile Overview</h4>
         <p>
            Client access accounts only exist in the context of an organization having a relationship with PEI. There are no purely individual accounts. The form supports finding an joining an existing organzation or requesting creation of a new organizational relationship.
         </p>

         <br />
         <h4>Terms of Service</h4>
         <p>
            Please refer to our <router-link to="terms" target="_blank">General Terms of Service</router-link> page and <router-link to="tpmterms" target="_blank">TPM Terms of Service</router-link> page
         </p>

         <br />
         <h4>Privacy Policy</h4>
         <p>
            Please refer to our <router-link to="privacy" target="_blank">Privacy Policy</router-link> page
         </p>

         <br />
         <p>
            Should you have any question or concern, please email <a href="mailto:info@pointent.com">info@pointent.com</a>.
         </p>
      </div>
   </div>
</template>
<script>
export default {
  name: 'SignupInfo'
}

</script>
